import {
  Card,
  styled,
  Flex,
  Grid,
  AccordionButton,
  AccordionPanel,
  AccordionItem,
} from '@grupoboticario/flora-react';

import { Card as CardBase, ProductImage, ResponsiveFloraTypography } from 'components';

const styles = {
  Wrapper: styled(Flex, {
    gridRow: '3',
    '@tablet': { gridColumn: '1 / span 2', gridRow: '2' },
  }),

  Grid: styled(Grid, {
    gap: '$4',
    paddingTop: '$4',

    '@tablet': {
      gridTemplateColumns: 'repeat(auto-fill, minmax(calc($20 * 4), 1fr))',
    },
  }),

  AccordionItem: styled(AccordionItem, {
    'button:first-child': {
      border: 'none',
      '&:hover:hover, &:focus:not([data-state="open"]):not(:hover)[data-state]': {
        border: 'none',
      },
    },
  }),

  AccordionButton: styled(AccordionButton, {
    padding: '0',
  }),

  AccordionPanel: styled(AccordionPanel, {
    'li:first-of-type': {
      padding: '0',
    },
  }),

  itemCard: styled(CardBase, {
    color: '$backgroundAltSecondary',
  }),

  ImageWrapper: styled(ProductImage, {
    width: '$8',
    border: '1px solid $backgroundSecondary',
    borderRadius: '$small',
    padding: '$1',
  }),

  ItemInfo: styled(Flex, {
    width: '100%',
  }),
  ItemName: styled(ResponsiveFloraTypography, {
    height: '$8',
    marginBottom: '$1',
    textTransform: 'capitalize',
    display: '-webkit-box',
    overflow: 'hidden',
    ' -webkit-line-clamp': '2',
    ' -webkit-box-orient': 'vertical',
  }),
  SkeletonItemCard: styled(Card, {
    width: '100%',
  }),
};

export default styles;
